import { regExps } from './formValidation/validationPatterns';

// restricts dots to one, decimal places to 2 and adds a leading 0 if it starts with a dot.
// For TextInputField values so expects and returns a string.
export const formatFloat = (value) => {
    if (!value) return '';
    let newValue = String(value);
    newValue = newValue.replace(regExps.DECIMALS_R, '');
    if (newValue.startsWith('.')) newValue = `0${newValue}`;
    const sets = newValue.split('.');
    if (sets.length > 2) newValue = `${sets[0]}.${sets.slice(1).join('')}`;
    return newValue.replace(regExps.CURRENCY_R, '$1');
};
